import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function Gallery() {
  const photos = [{
    url: 'https://cdn.magicpatterns.com/uploads/froqtLaTrU4sfsCTZo65n1/camp-group.jpg',
    alt: 'Campers group photo',
    className: 'aspect-[3/4] object-cover'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/1cVzY9WxpvuQmDLiJA6pso/sister-circle.jpg',
    alt: 'Sister circle gathering',
    className: 'aspect-square object-cover'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/gNtCRcz44oYku2JETSjmSY/tie-dye-day.jpg',
    alt: 'Tie dye day group',
    className: 'aspect-[4/5] object-cover'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/288tHxhpqXNwz7twcGjVJJ/hero-grass.jpg',
    alt: 'Camp landscape',
    className: 'aspect-[16/9] object-cover'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/froqtLaTrU4sfsCTZo65n1/camp-group.jpg',
    alt: 'Campers smiling',
    className: 'aspect-square object-cover object-top'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/1cVzY9WxpvuQmDLiJA6pso/sister-circle.jpg',
    alt: 'Campers in circle',
    className: 'aspect-[4/3] object-cover object-bottom'
  }];
  return <section id="gallery" className="bg-cream py-20 md:py-28" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-49">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-50">
            <h2 className="font-heading text-forest text-4xl md:text-5xl font-bold mb-4" data-id="element-51">
              Camp Memories
            </h2>
            <div className="w-20 h-1 bg-gold mb-6 rounded-full" data-id="element-52" />
          </motion.div>
        </div>

        {/* Masonry Grid */}
        <div className="columns-1 sm:columns-2 md:columns-3 gap-4 space-y-4" data-id="element-53">
          {photos.map((photo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="break-inside-avoid" data-id="element-54">
              <div className="rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer bg-brown/5" data-id="element-55">
                <img src={photo.url} alt={photo.alt} className={`w-full h-auto ${photo.className}`} loading="lazy" data-id="element-56" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}